import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { currentRouteSet } from "../../actions/actions";
import { pathSpliter } from "../../lib/functions";
import PurchaseInvoice from "./components/purchase_invoice";
import { API_URL } from "../../config";
import axios from "axios";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

let ViewPurchasePOInvoice = ({ location, history, currentRouteSet, authInfo }) => {
  let [invoices, invoicesSet] = useState([]);
  let [selectedInvoice, selectedInvoiceSet] = useState(null);
  let [purchaseId, purchaseIdSet] = useState(null);
  let [institution, institutionSet] = useState(null);
  let [po_id, po_id_set] = useState("");
  let [loading, loadingSet] = useState(false);
  let [open, setOpen] = useState(false);
  let submitBtnRef = useRef(null);

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getInstitution();
  }, []);

  let getPurchaseInvoices = async () => {
    loadingSet(true);
    try {
      const res = await axios.post(
        `${API_URL}/api/purchase-po-invoices`,
        { po_id: po_id },
        {
          headers: { "auth-token": authInfo.token },
        }
      );
      invoicesSet(res.data); // Update state with response data
      loadingSet(false);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      loadingSet(false);
      setOpen(true);
    }
  };

  let getInstitution = async () => {
    await axios
      .get(`${API_URL}/api/get-institution`, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        institutionSet(res.data);
      });
  };

  let processedSubmited = async () => {
    getPurchaseInvoices();
  };

  return (
    <Grid container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <TextField
              label="Chalan Number"
              variant="outlined"
              value={po_id}
              onChange={(e) => po_id_set(e.target.value)}
              name="purchase_invoice"
              onKeyDown={(e) => e.key === "Enter" && submitBtnRef.current?.click()}
            />
          </Grid>
          <Grid item>
            <Button
              buttonRef={submitBtnRef}
              variant="contained"
              color="primary"
              size="small"
              onClick={() => processedSubmited()}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item style={{ width: "100%", maxWidth: "400px" }}>
        <Autocomplete
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          autoHighlight={true}
          options={invoices}
          noOptionsText="Not Found"
          value={selectedInvoice}
          size="small"
          getOptionLabel={(option) => option.pur_invoice_no}
          onChange={(e, invoice) => {
            selectedInvoiceSet(invoice);
            if (invoice != null) {
              purchaseIdSet(invoice.pur_id);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Choose Purchase PO Invoice"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="primary" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </Grid>
      <Grid item style={{ width: "100%", marginTop: "10px" }}>
        <PurchaseInvoice purchaseId={purchaseId} institution={institution} history={history} />
      </Grid>
    </Grid>
  );
};

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
};

export default connect(mapStateToPops, { currentRouteSet })(ViewPurchasePOInvoice);
